<template>
  <div style="margin-top:20px;">
    <h2 class="mx-auto" style="margin-top:10px;">
      <span>{{ ehrSystemName }}</span>
    </h2>
    <!-- Logo -->
    <div class="form-row mb-10">
      <img class="mx-auto img-fluid" style="max-width: 99%; , height: auto;" :src="logoImagePath"  alt="[Get Picture]"/>
    </div>

    <!-- Token -->
    <ValidationObserver ref="obs" v-slot="{ invalid }">
      <div class="form-row mt-1 d-flex justify-content-center ">
        <ValidationProvider rules="digits:11" name="受付番号" vid="orderNumber" v-slot="{ errors }">
          <div class="container">
              <div class="row">
                <div class="col-xs-1">
                  <input type="number" pattern="\d*" 
                    class="form-control"
                    id="orderNumber"
                    name="受付番号"
                    placeholder="受付番号" 
                    v-model="orderNumber">
                </div>
                <div class="col-xs-1">
                  <button class="btn btn-outline-primary ml-1" v-on:click="onstatus" :disabled="invalid"><i class="fa fa-play-circle"></i>状況確認する</button>
                </div>
              </div>
          </div>
        <span style="color:#ff0000;margin-left: 10px;">{{ errors[0] }}</span>
        </ValidationProvider>
      </div>
    </ValidationObserver>

    <!-- Status -->
    <div class="align-items-center" style="margin-top:10px; ">
      <div data-toggle="modal" :data-target="withcomments" >
        <p class="align-items-center" style="font-size:130%;border-style:outset;padding: 10px;text-align: center;">
          <span>参加状況：</span>
          <span style="color: green;" id="displayName">{{displayName}}</span>
        </p>
      </div>
    </div>
    <div class="alert alert-light" role="alert">
      <span>{{explanation}}</span>
    </div>

    <!-- Consent modal -->
    <consent show-checkbox="false" :path="consentPath" ref="consent"/>

    <!-- Click Action -->
    <div class="form-group row" style="margin-top:50px;">
      <div class="col-sm-12" v-if="isShowNextBtn === true && isInitialized === true">
        <button class="btn btn-primary btn-block" v-on:click="onnext">{{ ehrSystemName }}へ参加する</button>
      </div>
    </div>

    <!-- adminComment Modal -->
    <div class="modal fade" id="adminCommentModalLong" tabindex="-1" role="dialog" aria-labelledby="adminCommentModalLongTitle" aria-hidden="true">
      <div class="modal-dialog modal-dialog-scrollable" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="adminCommentModalLongTitle">管理者からのコメント</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <pre>
{{adminComment}}
            </pre>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">閉じる</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Consent from './Consent.vue'

export default {
  name: "Top",
  components: {
    Consent
  },
  computed: {
    // 受付番号
    orderNumber: {
      get() {
        return this.$store.state.orderNumber;
      },
      set(val) {
        this.$store.commit("setOrderNumber", val);
      },    
    },
    ehrSystemName() {
      return this.$store.state.ehrSystem.ehrSystemName;
    },
    logoImagePath() {
      return process.env.VUE_APP_API_BASE_URL + this.$store.state.ehrSystem.logoImagePath;
    },
    consentPath() {
      return this.$store.state.ehrSystem.rulePath;
    },
    // 同意状態
    displayName() {
      return this.$store.state.displayName;
    },
    // 状態コメント
    explanation() {
      return this.$store.state.explanation;
    },
    // 管理者コメント
    adminComment() {
      return this.$store.state.adminComment;
    },
    withcomments() {
      return this.$store.state.withcomments;
    },    
    //「参加する」ボタンの表示（true:表示 false:非表示）
    isShowNextBtn() {
      return this.$store.state.isShowNextBtn;
    },
    //「参加する」ボタンの表示（true:表示 false:非表示）
    isInitialized() {
      return this.$store.state.isInitialized;
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  beforeRouteEnter(to, from, next) {

    const requestDomain = process.env.VUE_APP_API_BASE_URL;
    // 受付番号が引数にある場合（メールからの遷移）
    // 同意状況を取得しストアに保存
    next((vm) => {

      // 処理開始
      vm.$store.commit("setIsInitialized", false);

      if ( to.query.orderNumber !== undefined ) {

        vm.$store.commit("setOrderNumber", encodeURIComponent(to.query.orderNumber));
        vm.$store.commit("setArgOrderNumber", encodeURIComponent(to.query.orderNumber));
        vm.onstatus();
      
      } else {
          // phrAliasとphrUserIdを取得
          const phrAlias = vm.$store.state.phrSystem.phrAlias;
          const phrUserId = vm.$store.state.phrSystemLink.phrUserId;
          // orderNumberを取得
          const orderNumber = vm.$store.state.orderNumber;
          const criteria = {
                            "phrUserId": phrUserId, 
                            "phrAlias": phrAlias, 
                            "orderNumber": orderNumber
                          };
          vm.$store.dispatch("getConsentStatus", criteria)
          .catch(error => {
              // 受付番号存在判定
              if(JSON.parse(error.message).orderNumber){
                  //エラーあり（メッセージ設定表示）
                  vm.$refs.obs.setErrors(JSON.parse(error.message));
              } else {
                vm.$router.push("/syserr");
              }      
          });
      }
      // EHRシステムを検索
      vm.axios
        .post(requestDomain + "/rest/anonymous/ehrsystem/get", {})
        .then(function (response) {
          // EHRシステムをストアに保存
          vm.$store.commit("setEhrSystem", response.data);
          // EHR利用規約のロード
          vm.loadConsent(response.data.rulePath);
        })
        .catch(function (error) { // eslint-disable-line
          // システムエラー画面へ遷移
          next({ path: '/system-error' ,replace: true})
        })
        .finally(() => {
          // 処理済みに保存
          vm.$store.commit("setIsInitialized", true);
        });

    });
  },
  mounted() {
  },
  updated() {
    //受付番号に入力がない場合、「状況確認する」ボタンを無効に設定する
    if(!this.$store.state.orderNumber){
      this.invalid()
    }
  },
  methods: {
    invalid () {
      this.$refs.obs.flags.invalid=true
    },
    loadConsent(path) {
      this.$refs.consent.load([path]);
    },
    onstatus: function () {
      // phrAliasとphrUserIdを取得
      const phrAlias = "";
      const phrUserId = "";
      // orderNumberを取得
      const orderNumber = this.$store.state.orderNumber;
      const criteria = {
                        "phrUserId": phrUserId, 
                        "phrAlias": phrAlias, 
                        "orderNumber": orderNumber
                      };
      this.$store.dispatch("getConsentStatus", criteria)
      .catch(error => {
        // 受付番号存在判定
        if(JSON.parse(error.message).orderNumber){
             //エラーあり（メッセージ設定表示）
            this.$refs.obs.setErrors(JSON.parse(error.message));
        } else {
          this.$router.push("/syserr");
        }
      });      
    },    
    onnext: function() {
      this.$router.push("/info");
    }  
  },

  actions: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  text-align: center;
}
pre {
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    white-space: pre-wrap;
}
</style>
